// import Icon, { IconKey } from '../../Icon';
import './MenuButton.sass';

const MenuButton = ({ active, onClick }) => {
  return (
    <div className='menu-button-wrapper' onClick={() => onClick()}>
      {!active && <i className="fas fa-bars"/>}
      {active && <i className="fas fa-plus"/>}
    </div>
  );
};

export default MenuButton;
